module.exports = __webpack_public_path__ + "static/img/hy_ios.8210cde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy_ios.jpg
// module id = DraR
// module chunks = 0